import { useMemo } from 'react'
import { useAppSelector } from '../../../redux/store'
import { selectCurrentUser, selectIsAdminOrOwner } from '../../../redux/user'
import { Alert, Link } from '@mui/material'
import { getEPayLink } from '../../../services/epayService'
import { selectUpcomingShipments, selectAutoShipments } from './slice'
import CompliancePlip from '../../../components/CompliancePlip'
import useIsCorpView from '../../../hooks/useIsCorpView'
import useCustomerNumber from '../../../hooks/useCustomerNumber'
import CreditHoldBanner from '../../../components/CreditHoldBanner'
import CurrencyFormatter from '../../../components/CurrencyFormatter'
import UpcomingShipmentsNotice from '../../../components/UpcomingShipmentsNotice'
import { useNavigate } from 'react-router-dom'
import useCustomer from '../../../hooks/useCustomer'
import useCustomerBalance from '../../../hooks/useCustomerBalance'

const Alerts = () => {
  const customer = useCustomer()
  const isCorpView = useIsCorpView()  
  const customerNumber = useCustomerNumber()

  const autoShipments = useAppSelector(selectAutoShipments)
  const upcomingShipments = useAppSelector(selectUpcomingShipments)
  const currentUser = useAppSelector(selectCurrentUser)
  const isAdminOrOwner = useAppSelector(selectIsAdminOrOwner)
  const balance = useCustomerBalance()

  const metadata = customer.customerMetadata
  const showAutoclaveConfirmationAlert = (metadata?.autoclave_outstanding ?? 0) > 0

  const navigate = useNavigate()

  const customerHoldFlags = useMemo(() => {
    let showDEAHold = false
    let showCreditHold = false

    const date = new Date()
    date.setMonth(date.getMonth() + 2)
    date.setDate(0)

    const endNextMonth = new Date(date)

    if (upcomingShipments) {
      for (let shipment in upcomingShipments) {
        if (new Date(upcomingShipments[shipment][0].refill_period_name) < endNextMonth) {
          showCreditHold = true

          for (let item of upcomingShipments[shipment]) {
            if (item.hasControlledSubstance) {
              showDEAHold = true
            }
          }
        }
      }
    }

    return {
      showDEAHold,
      showCreditHold,
    }
  }, [upcomingShipments])

  const hasUpcomingShipments = useMemo(() => {
    return upcomingShipments ? Boolean(Object.keys(upcomingShipments).length) : false
  }, [upcomingShipments])

  const hasAutoshipments = Boolean(autoShipments?.length)

  if (!currentUser) return null

  const getNodusToken = async () => {
    const link = await getEPayLink(customerNumber, 'payments')
    window.open(link, '_blank')
  }

  const navigateToConfirmAutoclaveType = () => {
    if (isCorpView) {
      navigate(`/corp/practice/${customerNumber}/biological/confirm-autoclave-type`)
    } else {
      navigate(`/practice/biological/confirm-autoclave-type`)
    }
  }

  return (
    <>
      {showAutoclaveConfirmationAlert && (
        <Alert variant="filled" severity="error">
          ACTION REQUIRED: Review to confirm or update your autoclave types. <Link sx={{ color: 'lightskyblue', cursor: 'pointer' }} onClick={navigateToConfirmAutoclaveType}>Go to Confirmation Page</Link>
        </Alert>
      )}
      {hasUpcomingShipments || hasAutoshipments || (Boolean(balance) && balance > 0) ? (
        <div>
          <div className="panel-body">
            <ul className="list-group">
              {isAdminOrOwner && Boolean(balance) && balance > 0 && (customer.corporate_parent || !customer.is_bill_to_parent) && (
                <li className="list-group-item">
                  <CompliancePlip message='' className='.compliance-circle' status={3} />There is a remaining balance of <CurrencyFormatter className='balance-due' value={balance} />. <Link className="text-info" onClick={getNodusToken}>Pay Invoice</Link>
                </li>
              )}
              {(hasUpcomingShipments || hasAutoshipments) && (
                <UpcomingShipmentsNotice isCorpView={isCorpView} customerNumber={customerNumber} />
              )}
            </ul>
          </div>
        </div>
      ) : null}
      {
        customerHoldFlags?.showCreditHold && (
          <div>
            <CreditHoldBanner customer={customer} />
          </div>
        )
      }
    </>
  )
}

export default Alerts